module.exports = __webpack_public_path__ + "img/img-coins-left.88ef3d8.88ef3d80.png";